// Static content for EHR packages - not product data
export const facilitatorContent = {
  benefits: [
    "Streamline individual client sessions",
    "Reduce documentation time by 40%",
    "Mobile access for on-the-go updates",
    "Automated session reminders",
    "Secure client portal access",
    "Treatment progress tracking",
    "Billing integration for solo practice",
    "HIPAA-compliant data storage"
  ],
  
  content: {
    benefitsSection: {
      subtitle: "For Individual Practitioners",
      title: "Built for Facilitators Who Value Independence",
      primaryButton: "Start Free Trial",
      secondaryButton: "Watch Demo"
    },
    howItWorks: {
      title: "How Almadelic EHR Works For Facilitators",
      steps: [
        {
          title: "Choose a Healing Center",
          content: "Find nearest healing center location to conduct your practice & start healing."
        },
        {
          title: "Kick Off Patient Onboarding",
          content: "Enter your patient's email and start the automated onboarding process."
        },
        {
          title: "Start Preparation Session",
          content: "Start the healing journey and track your patient's progress. All compliant documents are generated and sent to the patient."
        },
        {
          title: "Monitor Sessions",
          content: "Continue to track patients, view documents, refer to past sessions, and view the overall healing journey."
        },
      ],
      image: {
        src: "https://almadelic-assets.s3.us-east-2.amazonaws.com/shop-assets/ehr-woman-agent.webp",
        alt: "Healthcare professional using EHR system on tablet"
      }
    }
  }
};

export const healingCenterContent = {
  benefits: [
    "Coordinate multiple practitioners seamlessly",
    "Centralized patient management system",
    "Advanced scheduling for group sessions",
    "Staff role-based access controls",
    "Multi-location reporting and analytics",
    "Integrated billing for all practitioners",
    "Automated insurance claim processing",
    "Custom workflows for your center"
  ],

  content: {
    benefitsSection: {
      subtitle: "For Multi-Practitioner Centers",
      title: "Scale Your Healing Center Operations",
      primaryButton: "Schedule Demo",
      secondaryButton: "View Features"
    },
    howItWorks: {
      title: "How Almadelic EHR Works For Healing Centers",
      steps: [
        {
          title: "Enroll Facilitators via Email",
          content: "We onboard facilitators through an automated process, starting with entering their email."
        },
        {
          title: "Faciltator Creates an Account",
          content: "Facilitator starts the onboarding process and creates their account with all necessary documents and information."
        },
        {
          title: "View Facilitator Status",
          content: "You can view the status of all facilitators in the system, including their account creation status and any necessary actions."
        },
        {
          title: "Monitor Your Business",
          content: "Check on your facilitators, their patients, sessions, and more."
        }
      ],
      image: {
        src: "https://almadelic-assets.s3.us-east-2.amazonaws.com/shop-assets/ehr-office-front.webp",
        alt: "Healthcare professional using Almadelic EHR system at healing center"
      }
    }
  }
};

// Features mapping for real Stripe products
export const getProductFeatures = (userType) => {
  if (userType === 'facilitator') {
    return [
      "Automated Document Generation & Signing",
      "Real-time patient lifecycle monitoring",
      "Ohio & Colorado Ready",
      "Unlimited patient records",
      "Session Management", 
      "HIPAA compliant storage",
      "Priority support"
    ];
  } else if (userType === 'healing center') {
    return [
      "Full Facilitator Management",
      "Full Patient Overview",
      "Automated Faciltator Onboarding",
      "Ohio & Colorado Ready",
      "HIPAA compliant storage",
      "Priority support"
    ];
  }
  return [];
};